import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ColorSchemeService } from '@techcrowd/tokens';

@Component({
  selector: 'tc-theme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      role="switch"
      class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent bg-input transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      [class.bg-primary]="colorScheme.isDark()"
      [attr.aria-checked]="colorScheme.isDark()"
      [attr.aria-label]="
        colorScheme.isDark() ? 'Zapnout světlý režim' : 'Zapnout tmavý režim'
      "
      [title]="colorScheme.isDark() ? 'Světlý režim' : 'Tmavý režim'"
      (click)="colorScheme.toggle()"
    >
      <span
        class="pointer-events-none flex h-5 w-5 items-center justify-center rounded-full bg-background shadow-sm transition-transform duration-200"
        [class.translate-x-5]="colorScheme.isDark()"
        [class.translate-x-0]="!colorScheme.isDark()"
        aria-hidden="true"
      >
        @if (colorScheme.isDark()) {
          <i class="ri-moon-line text-[10px] text-foreground"></i>
        } @else {
          <i class="ri-sun-line text-[10px] text-foreground"></i>
        }
      </span>
    </button>
  `,
})
export class ThemeToggleComponent {
  readonly colorScheme = inject(ColorSchemeService);
}
